import type { Program } from 'models';
import { useCallback, useMemo } from 'react';
import { Trans } from 'react-i18next';
import { Icon, Modal, message } from 'ui';
import { useLeaveProgramMutation } from '../../queries';

type P = {
  onLeaveSuccess: () => Promise<void>;
};

export const useConfirmLeaveProgram = ({ onLeaveSuccess }: P) => {
  const [modal, contextHolder] = Modal.useModal();

  const { mutateAsync: leaveProgramMutationAsync } = useLeaveProgramMutation();

  const confirmLeaveProgram = useCallback(
    (program: Program) => {
      modal.confirm({
        content: (
          <Trans
            components={{ strong: <strong /> }}
            i18nKey="Are you sure you want to unsubscribe <strong>{{programName}}</strong> program?"
            values={{ programName: program.name }}
          />
        ),
        icon: <Icon color="error" icon="minus-circle-line" />,
        okText: 'Unsubscribe',
        async onOk() {
          await leaveProgramMutationAsync(
            { programId: program.id },
            {
              async onSuccess() {
                message.success('You’ve successfully left the program');
                await onLeaveSuccess();
              },
            },
          );
        },
        title: 'Unsubscribe program',
        type: 'error',
      });
    },
    [leaveProgramMutationAsync, modal, onLeaveSuccess],
  );

  return useMemo(() => ({ confirmLeaveProgram, contextHolder }), [confirmLeaveProgram, contextHolder]);
};
